// Bridge so non-React code (axios interceptors) can raise the app's
// notifications. GlobalState registers its addNewNotifcation here on mount.

type NotifyType = 'danger' | 'success' | 'warning';
type NotifyFn = (message: string, type: NotifyType, timeremaining?: number) => void;

let handler: NotifyFn | null = null;

export function registerNotifier(fn: NotifyFn): void {
    handler = fn;
}

export function notify(message: string, type: NotifyType = 'danger', timeremaining = 5): void {
    if (handler) handler(message, type, timeremaining);
}

// Pull a human-readable message out of an axios error's response body.
export function extractServerMessage(error: any): string | null {
    const data = error?.response?.data;
    if (!data) return null;
    if (typeof data === 'string') return data;
    if (typeof data.message === 'string') return data.message;
    if (typeof data.error === 'string') return data.error;
    return null;
}
